export default "__VITE_ASSET__6a78ee32__"